<template>
  <v-card>
    <v-card-text>
      <v-layout justify-center>
        <v-flex xs8>
          <table style="width: 100%;">
            <tr>
              <td class="text-xs-left">
                <v-layout v-for="(pkg, index) in sortItems(item.pkgItems)" :key="String(pkg.tracking + index)">
                  <v-flex>
                    <span v-if="pkg.tracking === pkg.boxMark">{{ pkg.tracking }}</span>
                    <span v-else>
                      <span>{{ pkg.tracking }}</span>
                      <span v-if="pkg.boxMark">[{{ pkg.boxMark }}]</span>
                    </span>
                    <v-icon small color="primary" @click.stop="copyToClipboard(pkg.boxMark || pkg.tracking)">content_copy</v-icon>
                  </v-flex>
                  <v-tooltip top v-if="pkg.isCheckPackage">
                    <template v-slot:activator="data">
                      <v-flex right md1 v-on="data.on"><v-icon>add_task</v-icon></v-flex>
                    </template>
                    <span>{{ $t('needCheckPackage') }}</span>
                  </v-tooltip>
                </v-layout>
              </td>
              <td class="text-xs-left">
                <div v-for="(pkg, index) in sortItems(item.pkgItems)" :key="String(pkg.upc + index)">
                  {{ pkg.upc }}
                </div>
              </td>
              <td class="text-xs-left">
                <div
                  class="textOverflowHide"
                  v-for="(pkg, index) in sortItems(item.pkgItems)"
                  :key="String(pkg.upc + index)"
                >
                  {{ pkg.productName || getProductName(pkg.upc) || '' }}
                </div>
              </td>
              <td class="text-xs-left">
                <div
                  v-for="(pkg, index) in sortItems(item.pkgItems)"
                  :key="String(pkg.upc + index)"
                  :class="item.status === 'partial' && pkg.forecastQty !== pkg.inboundQty ? 'partial_highlight' : ''"
                >
                  {{ pkg.forecastQty || 0 }} /
                  {{ item.isPackageManagement && !pkg.isCheckPackage && pkg.inboundQty ? '**' : '' }}
                  {{ pkg.inboundQty || 0 }}
                </div>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>

import { checkRules, timeTools, copyToClipboard, cloneDeep } from '@/utils/tools'

export default {
  name: 'ForecastPackage',
  mixins: [checkRules, timeTools],

  computed: {
    products () {
      return this.$store.getters.productsWithUpcChangeableFlag || []
    }
  },
  methods: {
    sortItems (pkgItems) {
      const pkgs = cloneDeep(pkgItems)
      return pkgs.sort((a, b) => {
        const lastPartA = a.tracking.split('-').pop()
        const lastPartB = b.tracking.split('-').pop()

        const numA = parseInt(lastPartA, 10)
        const numB = parseInt(lastPartB, 10)

        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB
        } else {
          return lastPartA.localeCompare(lastPartB)
        }
      })
    },
    getProductName (upc) {
      return this.products.find(product => product.upc === upc || product.sku?.includes(upc))?.name
    },
    copyToClipboard (text) {
      try {
        copyToClipboard(text)
        this.$store.dispatch('showToast', { info: `${this.$t('copy')} ${this.$t('success')}`, level: 'success' })
      } catch (error) {
        this.$store.dispatch('showToast', { info: this.$t('fail'), level: 'error' })
        throw error
      }
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.partial_highlight {
  background-color: yellow;
}
.textOverflowHide {
  max-width: 200px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ForecastTableExpand.vue